import React from 'react';
import { Box, Loader, Stack, Text } from '@mantine/core';
import { motion, useReducedMotion } from 'framer-motion';
import ShellLogo from '@/components/appshell/Shell.Logo';

const SessionSplash: React.FC = () => {
    const reduced = useReducedMotion();

    return (
        <Box style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', backgroundColor: 'var(--bd-shell)' }}>
            <motion.div
                initial={reduced ? false : { opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.22, delay: 0.12 }}
            >
                <Stack align="center" gap="md">
                    <ShellLogo />
                    <Loader size="sm" />
                    <Text fz="sm" c="dimmed">Riprendo la sessione…</Text>
                </Stack>
            </motion.div>
        </Box>
    );
};

export default SessionSplash;
